import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Label,
  Input,
} from "reactstrap";
import { inviteUsers } from "../../../slices/general/thunk";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import Cleave from "cleave.js/react";
const InviteUserModal = ({ open, setOpen, onRefresh }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNum, setPhoneNum] = useState("");

  useEffect(() => {
    setEmail("");
    setFirstName("");
    setLastName("");
  }, [open]);


  const toggleUserModal = () => {
    setOpen(!open);
  };
  const handleInvite = async () => {
    try {
      setLoading(true);
      const res = await dispatch(inviteUsers({
        email,
        firstName,
        lastName,
        phoneNumber: phoneNum,
      }));

      const response = res.payload;

      console.log(response, res);

      if (response && !response.error) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "User invited successfully",
        });
        toggleUserModal();
        setEmail("");
        onRefresh();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.message || "Failed to invite user",
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal isOpen={open} toggle={toggleUserModal}>
        <>
          <ModalHeader toggle={toggleUserModal}>Invite User</ModalHeader>
          <ModalBody>
            {/* // First name and last naem in same row. */}

            {/* // First name */}
            <div className="d-flex">
              <div className="w-50">
                <div style={{
                  marginRight: "10px"
                }} className="mt-3">
                  <Label for="firstName">First Name</Label>
                  <Input
                    type="text"
                    id="firstName"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    placeholder="First name"
                  />
                </div>
              </div>
              {/* // Last name */}
              <div className="w-50">
                <div className="mt-3">
                  <Label for="lastName">Last Name</Label>
                  <Input
                    type="text"
                    id="lastName"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    placeholder="Last Name"
                  />
                </div>
              </div>
            </div>


            <div className="mt-3">
              <Label for="email">Email</Label>
              <Input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter the user's email"
              />
            </div>

            {/* Phone number input using Cleave */}

            <div className="mt-3">
              <Label for="phoneNum">Phone Number</Label>
              <Cleave
                className="form-control"
                options={{
                  numericOnly: true,
                  delimiters: [, "(", ")-", "-"],
                  blocks: [0, 0, 3, 3, 4],
                  delimiterLazyShow: true,
                }}
                onChange={(e) => {
                  setPhoneNum(e.target.value);
                }}
              />

            </div>


          </ModalBody>
          <ModalFooter>
            <Button
              disabled={loading}
              className="btn btn-primary w-100"
              onClick={handleInvite}
            >
              {loading ? <Spinner size="sm" /> : "Invite"}
            </Button>{" "}
          </ModalFooter>
        </>
      </Modal>
    </div>
  );
};

export default InviteUserModal;
